import { state } from '@angular/animations';
import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { IGroupedProducts, IProducts } from '../models/products.model';

export const groupedProductsForSomeoneElseFeatureKey = 'groupedProductsForSomeoneElse';

export interface GroupedProductsForSomeoneElseState {
  loadGroupedProductsForSomeoneElse: string;
  loadGroupedProductsForSomeoneElseResponse: IGroupedProducts[];
  loadGroupedProductsForSomeoneElseFailure: Error | any;
}

export const initialState: GroupedProductsForSomeoneElseState = {
  loadGroupedProductsForSomeoneElse: undefined,
  loadGroupedProductsForSomeoneElseResponse: undefined,
  loadGroupedProductsForSomeoneElseFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadGroupedProductsForSomeoneElse, (state, action) => ({
    ...state,
    loadGroupedProductsForSomeoneElse: action.request
  })),
  on(actions.loadGroupedProductsForSomeoneElseSuccess, (state, action) => ({
    ...state,
    loadGroupedProductsForSomeoneElseResponse: action.response
  })),
  on(actions.loadGroupedProductsForSomeoneElseFailure, (state, action) => ({
    ...state,
    loadGroupedProductsForSomeoneElseFailure: action.error
  }))
);

export const getGroupedProductsForSomeoneElseResponse = (state: GroupedProductsForSomeoneElseState) =>
  state.loadGroupedProductsForSomeoneElseResponse;
